unit View.Bancos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UConstantes, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, System.StrUtils;

type
  TFViewBancosList = class(TForm)
    BancosDataset: TXDataWebDataSet;
    BancosDatasetid: TIntegerField;
    BancosDatasetnome: TStringField;
    BancosDatasetcodigo: TStringField;
    BancosDatasetdigital: TBooleanField;
    BancosDatasetcodigo_interno: TIntegerField;
    BancosDatasetexcluido: TBooleanField;
    BancosDatasetinclusao: TDateTimeField;
    BancosDatasetalteracao: TDateTimeField;
    BancosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    BancosDatasetcodigo_cliente: TIntegerField;
    BancosDatasetultima_sinc_ws: TDateTimeField;
    BancosDatasetconsulta_sinc_ws: TDateTimeField;
    BancosDatasetbanco_sincid: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewBancosList: TFViewBancosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBancosList }

procedure TFViewBancosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewBancosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBancosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewBancosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewBancosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewBancosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewBancosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewBancosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      BancosDataset.Connection.Model.DefaultSchema.FindEntityType(BancosDataset.EntitySetName),
      BancosDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_banco');
  end;
end;

procedure TFViewBancosList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome']) of
      0 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewBancosList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['digital', 'excluido', 'banco_sinc.id']) of
    0, 1:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
    2:
    begin
      if AValue.IsEmpty then
         AValue := '<i class="fas fa-times text-danger"><i>'
      else
        AValue := '<i class="fas fa-check text-success"><i>';
    end;
  end;
end;

procedure TFViewBancosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('bancos', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, BancosDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewBancosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.bancos.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.bancos.list.table');
  cbPageSize := TComboBox.Create('view.bancos.list.cbPageSize');
  edSearch := TEdit.Create('view.bancos.list.search');
  lcPaginator := TListControl.Create('view.bancos.list.pagination');
  BancosDataset := TXDataWebDataSet.Create(Self);
  BancosDatasetid := TIntegerField.Create(Self);
  BancosDatasetnome := TStringField.Create(Self);
  BancosDatasetcodigo := TStringField.Create(Self);
  BancosDatasetdigital := TBooleanField.Create(Self);
  BancosDatasetcodigo_interno := TIntegerField.Create(Self);
  BancosDatasetexcluido := TBooleanField.Create(Self);
  BancosDatasetinclusao := TDateTimeField.Create(Self);
  BancosDatasetalteracao := TDateTimeField.Create(Self);
  BancosDatasetexclusao := TDateTimeField.Create(Self);
  BancosDatasetcodigo_cliente := TIntegerField.Create(Self);
  BancosDatasetultima_sinc_ws := TDateTimeField.Create(Self);
  BancosDatasetconsulta_sinc_ws := TDateTimeField.Create(Self);
  BancosDatasetbanco_sincid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  BancosDataset.BeforeLoadDFMValues;
  BancosDatasetid.BeforeLoadDFMValues;
  BancosDatasetnome.BeforeLoadDFMValues;
  BancosDatasetcodigo.BeforeLoadDFMValues;
  BancosDatasetdigital.BeforeLoadDFMValues;
  BancosDatasetcodigo_interno.BeforeLoadDFMValues;
  BancosDatasetexcluido.BeforeLoadDFMValues;
  BancosDatasetinclusao.BeforeLoadDFMValues;
  BancosDatasetalteracao.BeforeLoadDFMValues;
  BancosDatasetexclusao.BeforeLoadDFMValues;
  BancosDatasetcodigo_cliente.BeforeLoadDFMValues;
  BancosDatasetultima_sinc_ws.BeforeLoadDFMValues;
  BancosDatasetconsulta_sinc_ws.BeforeLoadDFMValues;
  BancosDatasetbanco_sincid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewBancosList';
    Width := 611;
    Height := 382;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 320;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'digital';
      Title := 'digital';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'banco_sinc.id';
      Title := 'Sinc. Autom'#225'tica';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo';
      Title := 'C'#243'd. Banco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_cliente';
      Title := 'C'#243'd. Cliente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'consulta_sinc_ws';
      Title := 'Consulta Sinc. WS';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ultima_sinc_ws';
      Title := #218'ltima Sinc. WS';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 309;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    BancosDataset.SetParentComponent(Self);
    BancosDataset.Name := 'BancosDataset';
    BancosDataset.EntitySetName := 'Bancos';
    BancosDataset.Connection := DMConnection.ApiConnection;
    BancosDataset.Left := 72;
    BancosDataset.Top := 88;
    BancosDatasetid.SetParentComponent(BancosDataset);
    BancosDatasetid.Name := 'BancosDatasetid';
    BancosDatasetid.Tag := 1;
    BancosDatasetid.FieldName := 'id';
    BancosDatasetid.Required := True;
    BancosDatasetnome.SetParentComponent(BancosDataset);
    BancosDatasetnome.Name := 'BancosDatasetnome';
    BancosDatasetnome.FieldName := 'nome';
    BancosDatasetnome.Required := True;
    BancosDatasetnome.Size := 255;
    BancosDatasetcodigo.SetParentComponent(BancosDataset);
    BancosDatasetcodigo.Name := 'BancosDatasetcodigo';
    BancosDatasetcodigo.FieldName := 'codigo';
    BancosDatasetcodigo.Size := 255;
    BancosDatasetdigital.SetParentComponent(BancosDataset);
    BancosDatasetdigital.Name := 'BancosDatasetdigital';
    BancosDatasetdigital.FieldName := 'digital';
    BancosDatasetdigital.Required := True;
    BancosDatasetcodigo_interno.SetParentComponent(BancosDataset);
    BancosDatasetcodigo_interno.Name := 'BancosDatasetcodigo_interno';
    BancosDatasetcodigo_interno.FieldName := 'codigo_interno';
    BancosDatasetcodigo_interno.Required := True;
    BancosDatasetexcluido.SetParentComponent(BancosDataset);
    BancosDatasetexcluido.Name := 'BancosDatasetexcluido';
    BancosDatasetexcluido.FieldName := 'excluido';
    BancosDatasetinclusao.SetParentComponent(BancosDataset);
    BancosDatasetinclusao.Name := 'BancosDatasetinclusao';
    BancosDatasetinclusao.FieldName := 'inclusao';
    BancosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetalteracao.SetParentComponent(BancosDataset);
    BancosDatasetalteracao.Name := 'BancosDatasetalteracao';
    BancosDatasetalteracao.FieldName := 'alteracao';
    BancosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetexclusao.SetParentComponent(BancosDataset);
    BancosDatasetexclusao.Name := 'BancosDatasetexclusao';
    BancosDatasetexclusao.FieldName := 'exclusao';
    BancosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    BancosDatasetcodigo_cliente.SetParentComponent(BancosDataset);
    BancosDatasetcodigo_cliente.Name := 'BancosDatasetcodigo_cliente';
    BancosDatasetcodigo_cliente.FieldName := 'codigo_cliente';
    BancosDatasetultima_sinc_ws.SetParentComponent(BancosDataset);
    BancosDatasetultima_sinc_ws.Name := 'BancosDatasetultima_sinc_ws';
    BancosDatasetultima_sinc_ws.FieldName := 'ultima_sinc_ws';
    BancosDatasetultima_sinc_ws.DisplayFormat := 'dd/mm/yy';
    BancosDatasetconsulta_sinc_ws.SetParentComponent(BancosDataset);
    BancosDatasetconsulta_sinc_ws.Name := 'BancosDatasetconsulta_sinc_ws';
    BancosDatasetconsulta_sinc_ws.FieldName := 'consulta_sinc_ws';
    BancosDatasetconsulta_sinc_ws.DisplayFormat := 'dd/mm/yy';
    BancosDatasetbanco_sincid.SetParentComponent(BancosDataset);
    BancosDatasetbanco_sincid.Name := 'BancosDatasetbanco_sincid';
    BancosDatasetbanco_sincid.FieldName := 'banco_sinc.id';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := BancosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 455;
    tmrConsulta.Top := 248;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    BancosDataset.AfterLoadDFMValues;
    BancosDatasetid.AfterLoadDFMValues;
    BancosDatasetnome.AfterLoadDFMValues;
    BancosDatasetcodigo.AfterLoadDFMValues;
    BancosDatasetdigital.AfterLoadDFMValues;
    BancosDatasetcodigo_interno.AfterLoadDFMValues;
    BancosDatasetexcluido.AfterLoadDFMValues;
    BancosDatasetinclusao.AfterLoadDFMValues;
    BancosDatasetalteracao.AfterLoadDFMValues;
    BancosDatasetexclusao.AfterLoadDFMValues;
    BancosDatasetcodigo_cliente.AfterLoadDFMValues;
    BancosDatasetultima_sinc_ws.AfterLoadDFMValues;
    BancosDatasetconsulta_sinc_ws.AfterLoadDFMValues;
    BancosDatasetbanco_sincid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
